import { render, staticRenderFns } from "./create.vue?vue&type=template&id=515bbba5"
import script from "./create.ts?vue&type=script&lang=js&external"
export * from "./create.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports